const initialState = {
  tableContent: [],
}

export const searchTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_TABLE':
      return {
        ...state,
        tableContent: action.payload,
      }
    default:
      return state
  }
}
